<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_overtime" transform="translate(1451 3000)">
      <path
        id="패스_4053"
        data-name="패스 4053"
        fill="none"
        d="M0,0H24V24H0Z"
        transform="translate(-1451 -3000)"
      />
      <path
        id="overtime"
        fill="#ffc304"
        d="M12,21a8.679,8.679,0,0,1-6.375-2.625A8.679,8.679,0,0,1,3,12,8.679,8.679,0,0,1,5.625,5.625,8.679,8.679,0,0,1,12,3q.35,0,.688.025t.662.075A5.4,5.4,0,0,0,11.1,7.5a5.208,5.208,0,0,0,1.575,3.825A5.208,5.208,0,0,0,16.5,12.9a5.355,5.355,0,0,0,4.4-2.25q.05.325.075.662T21,12a8.679,8.679,0,0,1-2.625,6.375A8.679,8.679,0,0,1,12,21Z"
        transform="translate(-1451 -3000)"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
